import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { SectionsPropsType } from '../types';
import { renderAdvisorMessage } from '../../views/AdvisorMessage';
import { scrollToBottomOfChat } from '../../functional/scrollToBottomOfChat';
import { renderSingleImage } from '../../views/SingleImage';

import KaeruWaitEstimateGifPath from 'Images/me/pages/guest/proposals/new/last_message/kaeru_wait_estimate.gif'

const SECTION_KEY_NAME = 'lastMessage';

export const lastMessageSection = async (props: SectionsPropsType) => {
  // アドバイザーの吹き出し
  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    isVisibleAvatar: true,
    messageElement: (
      <>
        ご回答ありがとうございました。
      </>
    ),
  });

  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    isVisibleAvatar: true,
    messageElement: (
      <>
        いただいた条件にて、検索が完了しました。<br />
        LINE登録をして、結果をご確認ください。
      </>
    ),
  });

  await renderSingleImage({
    ...props,
    keyName: SECTION_KEY_NAME,
    imagePaths: {
      imagePath: KaeruWaitEstimateGifPath,
    },
    altText: '結果が楽しみ！',
    viewWidth: {
      pc: 176,
      mobile: 136,
    },
    imageRatio: { width: 176, height: 150 },
    delayTime: 3,
  });

  // スクロールする
  scrollToBottomOfChat();
};
